import { getToken } from '../../helpers/helpers';
import { toggleModal } from './toggleModalActions';

export const loadCommentsPending = () => {
    return {
        type: 'LOAD_COMMENTS_PENDING',
    }
};
export const loadCommentsSuccess = (payload) => {
    return {
        type: 'LOAD_COMMENTS_SUCCESS',
        payload
    }
};

export const refreshCommentsPending = () => {
    return {
        type: 'REFRESH_COMMENTS_PENDING'
    }
};

export const refreshCommentsSuccess = () => {
    return {
        type: 'REFRESH_COMMENTS_SUCCESS'
    }
};

export const refreshCommentsError = error => {
    return {
        type: 'REFRESH_COMMENTS_ERROR',
        error: error
    }
};

export const deleteLastCommentPending = () => {
  return {
    type: 'DELETE_LAST_COMMENT_PENDING'
  }
};

export const deleteLastCommentSuccess = res => {
  return {
    type: 'DELETE_LAST_COMMENT_SUCCESS',
    deleteMessage: res
  }
};

export const deleteLastCommentError = error => {
  return {
    type: 'DELETE_LAST_COMMENT_ERROR',
    error: error
  }
};

export const refreshComments = () => {
    return dispatch => {
        dispatch(refreshCommentsPending());

        fetch(`${process.env.REACT_APP_API_URL}/ipsad/update_ipsad_content`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': getToken(),
            }
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(refreshCommentsSuccess());
                    dispatch(toggleModal(true, 'commentsRefreshSuccess'));
                } else {
                    dispatch(refreshCommentsError(`Error: ${res.status} ${res.statusText}`));
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const deleteLastComment = () => {
    return dispatch => {
        dispatch(deleteLastCommentPending());

        fetch(`${process.env.REACT_APP_API_URL}/ipsad/delete_latest_comments`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': getToken(),
            }
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(deleteLastCommentSuccess(res));
                    dispatch(toggleModal(true, 'lastCommentDeleteSuccess'));
                } else {
                    dispatch(deleteLastCommentError(`Error: ${res.status} ${res.statusText}`));
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const sendNotificationForLastComment = (data, closeMethod) => {
    return dispatch => {
        fetch(`${process.env.REACT_APP_API_URL}/ipsad/send_latest_post_notification`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': getToken(),
            },
            body: JSON.stringify(data)
        })
            .then(res => {
                if (res.status === 200) {
                    closeMethod();
                    dispatch(toggleModal(true, 'notificationSent'));
                } else {
                    closeMethod();
                    dispatch(deleteLastCommentError(`Error: ${res.status} ${res.statusText}`));
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const sendNotificationForSpecificComment = (data, closeMethod) => {
    return dispatch => {
        fetch(`${process.env.REACT_APP_API_URL}/ipsad/send_ipsad_post_notification`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': getToken(),
            },
            body: JSON.stringify(data)
        })
            .then(res => {
                if (res.status === 200) {
                    closeMethod();
                    dispatch(toggleModal(true, 'notificationSent'));
                } else {
                    closeMethod();
                    dispatch(deleteLastCommentError(`Error: ${res.status} ${res.statusText}`));
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const loadComments = () => {
    return dispatch => {
        dispatch(loadCommentsPending());

        fetch(`${process.env.REACT_APP_API_URL}/ipsad/comments`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': getToken(),
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json();
                } else {
                    dispatch(refreshCommentsError(`Error: ${res.status} ${res.statusText}`));
                }
            })
            .then(res => {
                dispatch(loadCommentsSuccess(res.ipsadPosts));
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};
